import {
  createTheme,
  Grid,
  MenuItem,
  Select,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Stack } from "react-bootstrap";
import { themeOptions } from "../../../theme";
import ComponentHeader from "../../ComponentHeader";
import { makeStyles, styled } from "@mui/styles";
import LeaderboardListTable from "../LeaderboardListTabel";
import POTYTournamentDetails from "../../../pages/POTYTournamentDetails";
import LeaderboardTable from "../LeaderboardTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getLeaderboardProjectedScore } from "../../../redux/actions/leaderboard-actions";
import { getPotyTournamentSeasons } from "../../../redux/actions/leaderboard-actions";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    // height: "40px",
    // "& * > input": {
    //   padding: "5px !important",
    // },
    // "& > div": {
    //   padding: "10px !important",
    // },
    // padding: "5px !important"
  },
}));

export default function LeaderboardList() {
  const dispatch = useDispatch();
  const theme = createTheme(themeOptions);

  const getProjectedScores = useSelector(
    (state) => state?.getProjectedScoresByID?.data?.data
  );
  const getProjectedScoresLoading = useSelector(
    (state) => state?.getProjectedScoresByID?.data
  );

  const getPotyTournamentSeason = useSelector(
    (state) => state?.getPotyTournamentSeason?.data?.data
  );

  const classes = useStyles();

  const [seasonVal, setSeasonVal] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [isValueSelected, setIsValueSelected] = useState(false);
  const [leaderboardScoreVal, setLeaderboardScoreVal] = useState([]);
  const [dataProgressPending, setDataProgressPending] = useState(false);
  const [leaderboardScore, setLeaderboardScore] = useState([
    {
      points: "",
      playerName: "",
      handicap: "",
      grossScore: "",
      netScroe: "",
      holes: [],
      index: [],
      parValues: [],
      strokes: [],
      netScore: [],
    },
  ]);

  const [tournamentSeason, setTournamentSeason] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const _handleSelectSeasonVal = (e, item, childIndex) => {
    const { value } = e.target;
    setSeasonVal(item.name);
    setSelectedId(item._id);
    const l_selectedId = selectedId;
    setDataProgressPending(true);
  };

  useEffect(() => {
    if (selectedId) {
      dispatch(getLeaderboardProjectedScore(selectedId));
      localStorage.setItem("selectedID", selectedId);
    }
  }, [selectedId]);

  useEffect(() => {
    dispatch(getPotyTournamentSeasons());
  }, []);

  useEffect(() => {
    var l_getProjectedScores = getProjectedScores?.map((item) => {
      return {
        ...item,
        holes: item.score_card,
      };
    });
    setLeaderboardScoreVal(l_getProjectedScores);
    setDataProgressPending(false);
  }, [getProjectedScores]);

  useEffect(() => {
    setTournamentSeason(getPotyTournamentSeason);
  }, [getPotyTournamentSeason]);

  return (
    <ThemeProvider theme={theme}>
      <Grid container>
        <Grid item xs={12} p={3}>
          <Grid item container>
            <Grid item xs={8}>
              <Typography variant="h6">Leaderboard</Typography>
            </Grid>
            <Grid item xs={4}>
              <Stack>
                <Typography>Please Select Season</Typography>
                <Select
                  variant="outlined"
                  className={classes.outlineInputBorder}
                  value={seasonVal}
                  // fullWidth
                  label="."
                >
                  {tournamentSeason &&
                    tournamentSeason?.map((item, i) => {
                      return (
                        <MenuItem
                          key={item?._id}
                          value={item?.name}
                          onClick={(e) => {
                            // setSelectedId(item?._id);
                            _handleSelectSeasonVal(e, item);
                          }}

                          // onClick={(e) => {
                          //   _handleSelectMenuItem(e);
                          //   // changeToggleStates(item.name);
                          //   // _handleMenuTypeVal(item.id);
                          // }}
                        >
                          <Grid container item>
                            <Grid item xs={10}>
                              <Typography>{item?.name}</Typography>
                            </Grid>
                          </Grid>
                        </MenuItem>
                      );
                    })}

                  {/* );
                        })} */}
                </Select>
              </Stack>
            </Grid>
          </Grid>

          <Grid item container>
            <Grid item xs={12} mt={2}>
              {/* <LeaderboardListTable
                isValueSelected={isValueSelected}
              // isItemSelected={isItemSelected}
              // setIsItemSelected={setIsItemSelected}
              // leagueListData={leagueListData}
              // setSelectedRows={setSelectedRows}
              // onChangeSelecteableDelete={onChangeSelecteableDelete}
              /> */}
              {/* <LeaderboardTable /> */}
              <POTYTournamentDetails
                leaderboardScoreVal={leaderboardScoreVal}
                isLoading={isLoading}
                dataProgressPending={dataProgressPending}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
